import AdminChannelService from "./admin/channelService";
import AdminFlightInfoService from "./admin/flightInfoService";
import AdminFormService from "./admin/formService";
import AdminResponsibleService from "./admin/responsibleService";
import AdminTopicService from "./admin/topicService";
import AdminExternalUserService from "./admin/externalUserService";
import ComplaintService from "./complaintService";
import FileService from "./fileService";
import MasterService from "./masterService";
import TicketChannelService from "./ticketChannelService";
import UserService from "./userService";
import AuthService from "./authService";
import FormService from "./formService";
import FlightService from "./flightService";
import CommonService from "./commonService";
import ReportService from "./reportService";
import AdminUserService from "./admin/userService";
import RoleService from "./roleService";
const masterService = new MasterService();
const adminFlightInfoService = new AdminFlightInfoService();
const adminExternalUserService = new AdminExternalUserService();
const adminUserService = new AdminUserService();
const adminTopicService = new AdminTopicService();
const adminFormService = new AdminFormService();
const adminChannelService = new AdminChannelService();
const adminResponsibleService = new AdminResponsibleService();
const ticketChannelService = new TicketChannelService();
const complaintService = new ComplaintService();
const userService = new UserService();
const fileService = new FileService();
const authService = new AuthService();
const formService = new FormService();
const flightService = new FlightService();
const reportService = new ReportService();
const roleService = new RoleService();

export {
  masterService,
  adminFlightInfoService,
  adminUserService,
  adminExternalUserService,
  adminTopicService,
  adminFormService,
  adminChannelService,
  adminResponsibleService,
  ticketChannelService,
  complaintService,
  userService,
  fileService,
  authService,
  formService,
  flightService,
  reportService,
  roleService,
};
